<template>
    <div>
        <NavBar/>
        <div class="container mx-auto text-center">
            <h2 class="text-muted heading">QR Codes</h2>
            <a :href="'https://' + WEBAPP_URL + '/#/auth/signIn?redirect=' + APP_URL" class="btn btn-primary">Sign in</a>
        </div>
    </div>
</template>

<script>
import { WEBAPP_URL } from '../amplify/config'
import NavBar from '../components/NavBar'

export default {
    name: 'Unauthorized',
    components: { NavBar },
    data () {
        return {
            WEBAPP_URL,
            APP_URL: location.origin
        }
    }
}
</script>

<style scoped>
    .heading {
        margin-top: 100px;
        margin-bottom: 50px;
    }
</style>
